module.exports = __webpack_public_path__ + "static/media/exedros.05ca07ca.png";